import {Outlet, useLocation} from "react-router-dom";
import {useEffect} from "react";
import {Navigation} from "../components/LegalPage/Navigation";

import '../components/LegalPage/LegalPage.scss'

export const LegalPage = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.replace('#', '');
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView();
            } else {
                // Element may not be in DOM yet (lazy-loaded chunk still mounting)
                const timer = setTimeout(() => {
                    document.getElementById(id)?.scrollIntoView();
                }, 300);
                return () => clearTimeout(timer);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return (
        <div className='legal-page-container'>

            <div>
                <Navigation />
            </div>

            <div className='legal-page-container__content'>
                <Outlet />
            </div>
        </div>
    )
}
